// Rótulo de «Paso donde quedó»: la pantalla exacta; si no hay, el paso de entrada del silo; el último
// completado solo si el silo no dijo nada. Con el número del stepper (`label`), no el de la máquina.
import { stepById, stepBySlug } from '@/domains/sales/wizard/steps';
import type { ResumeTarget, WizardStepId, WizardStepSlug } from '@/domains/sales/wizard/types';

interface SavedScreenSource {
    resumeSlug?: WizardStepSlug | null;
    resumeTargetStep?: WizardStepId | null;
    resumeTarget?: ResumeTarget | null;
    currentStep: WizardStepId | null;
}

export function savedScreenLabel(session: SavedScreenSource | undefined): string | null {
    if (!session) return null;
    const step =
        (session.resumeSlug && stepBySlug(session.resumeSlug)) ||
        (session.resumeTargetStep && stepById(session.resumeTargetStep)) ||
        (session.resumeTarget && stepById(session.resumeTarget.step)) ||
        (session.currentStep && stepById(session.currentStep)) ||
        undefined;
    return step ? `${step.label} · ${step.title}` : null;
}
